module.exports = __webpack_public_path__ + "static/media/10257.d7dd757e.jpg";